import { OrganizationMembersTable } from "@/components/tables/organization-members-table";

export function OrganizationSettingsMembers() {
	/** Render */
	return <OrganizationMembersTable />;
}
